import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import NeoModal from "../../../../components/Common/NeoModal";
import NeoInput from "../../../../components/Common/NeoInput";
import NeoButton from "../../../../components/Common/NeoButton";

const DetailActionModals = ({
    modalAction,
    onClose,
    tenant,
    tempPlan,
    tempTrialStartDate,
    tempTrialEndsAt,
    platformPlans,
    loadingPlans,
    changingPlan,
    changingTrial,
    onChangeTempPlan,
    onChangeTempTrialStartDate,
    onChangeTempTrialEndsAt,
    onPlanChange,
    onTrialChange,
    onBlockToggle,
    liberateDays,
    onChangeLiberateDays,
    onLiberateTemporarily,
    onImpersonate,
    selectedFatura,
    onPayFatura
}) => {
    if (!modalAction || !tenant) return null;

    return (
        <>
            {/* Modal Alterar Plano */}
            <NeoModal
                isOpen={modalAction === "plan"}
                toggle={onClose}
                title="Alterar Plano Comercial"
                subtitle="A alteração de plano irá redefinir o valor mensal da assinatura e atualizar os limites de recursos."
                footerActions={
                    <>
                        <NeoButton variant="secondary" onClick={onClose}>Cancelar</NeoButton>
                        <NeoButton
                            variant="primary"
                            onClick={onPlanChange}
                            disabled={loadingPlans || changingPlan || !tempPlan}
                        >
                            {changingPlan ? "Alterando..." : "Confirmar Mudança"}
                        </NeoButton>
                    </>
                }
            >
                <NeoInput
                    label="Selecione o Novo Plano"
                    type="select"
                    value={tempPlan}
                    onChange={(e) => onChangeTempPlan(e.target.value)}
                    disabled={loadingPlans || changingPlan}
                    options={
                        loadingPlans
                            ? [{ value: "", label: "Carregando planos..." }]
                            : platformPlans.length > 0
                                ? platformPlans.map((plan) => ({
                                    value: plan.id,
                                    label: `${plan.title || plan.id} - R$ ${Number(plan.price || plan.amount || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}/mês`,
                                }))
                                : [{ value: "", label: "Nenhum plano comercial ativo encontrado" }]
                    }
                />
            </NeoModal>

            {/* Modal Alterar Trial */}
            <NeoModal
                isOpen={modalAction === "trial"}
                toggle={onClose}
                title="Alterar Período de Trial"
                subtitle="Atualize a janela de teste da academia. As datas são salvas como calendário no formato YYYY-MM-DD."
                footerActions={
                    <>
                        <NeoButton variant="secondary" onClick={onClose}>Cancelar</NeoButton>
                        <NeoButton
                            variant="primary"
                            onClick={onTrialChange}
                            disabled={changingTrial || !tempTrialStartDate || !tempTrialEndsAt}
                        >
                            {changingTrial ? "Salvando..." : "Salvar Trial"}
                        </NeoButton>
                    </>
                }
            >
                <Row className="g-3">
                    <Col md={6}>
                        <NeoInput
                            label="Início do Trial"
                            type="date"
                            value={tempTrialStartDate}
                            onChange={(e) => onChangeTempTrialStartDate(e.target.value)}
                            disabled={changingTrial}
                        />
                    </Col>
                    <Col md={6}>
                        <NeoInput
                            label="Fim do Trial"
                            type="date"
                            value={tempTrialEndsAt}
                            onChange={(e) => onChangeTempTrialEndsAt(e.target.value)}
                            disabled={changingTrial}
                        />
                    </Col>
                </Row>
            </NeoModal>

            {/* Modal Bloquear/Desbloquear */}
            <NeoModal
                isOpen={modalAction === "block"}
                toggle={onClose}
                title={tenant.status === "blocked" ? "Reativar Acesso" : "Bloquear Acesso"}
                footerActions={
                    <>
                        <NeoButton variant="secondary" onClick={onClose}>Cancelar</NeoButton>
                        <NeoButton variant={tenant.status === "blocked" ? "success" : "danger"} onClick={onBlockToggle}>Confirmar</NeoButton>
                    </>
                }
            >
                {tenant.status === "blocked" ? (
                    <p>Tem certeza que deseja liberar novamente o acesso para a academia <strong>{tenant.name}</strong>? O proprietário e toda a equipe voltarão a conseguir fazer login no sistema.</p>
                ) : (
                    <p className="text-danger fw-bold mb-0">
                        ⚠️ AVISO: Esta ação impedirá o acesso imediato de todos os usuários da academia {tenant.name} ao painel e ao aplicativo de alunos. Recomenda-se realizar o bloqueio apenas em caso de inadimplência superior a 15 dias.
                    </p>
                )}
            </NeoModal>

            {/* Modal Liberação Temporária */}
            <NeoModal
                isOpen={modalAction === "temp_liberate"}
                toggle={onClose}
                title="Liberar Acesso Temporário"
                subtitle="O acesso será reativado de forma provisória para negociação comercial."
                footerActions={
                    <>
                        <NeoButton variant="secondary" onClick={onClose}>Cancelar</NeoButton>
                        <NeoButton variant="primary" onClick={onLiberateTemporarily}>Liberar Acesso</NeoButton>
                    </>
                }
            >
                <p>Defina o prazo de dias de extensão temporária para o acesso da academia inadimplente.</p>
                <NeoInput
                    label="Dias de Liberação"
                    type="select"
                    value={liberateDays}
                    onChange={(e) => onChangeLiberateDays(Number(e.target.value))}
                    options={[
                        { value: 3, label: "3 Dias Úteis" },
                        { value: 5, label: "5 Dias Úteis" },
                        { value: 7, label: "7 Dias Úteis" }
                    ]}
                />
            </NeoModal>

            {/* Modal Login como Cliente */}
            <NeoModal
                isOpen={modalAction === "impersonate"}
                toggle={onClose}
                title="Entrar como Cliente (Impersonate)"
                subtitle="Esta operação é restrita, será auditada pela segurança e gerará um log obrigatório."
                footerActions={
                    <>
                        <NeoButton variant="secondary" onClick={onClose}>Cancelar</NeoButton>
                        <NeoButton variant="primary" onClick={onImpersonate}>Acessar Painel</NeoButton>
                    </>
                }
            >
                <p>Você está prestes a entrar no painel administrativo da academia <strong>{tenant.name}</strong>.</p>
                <NeoInput label="Motivo do Acesso *" placeholder="Ex: Suporte técnico para ajuste de fechamento financeiro" />
            </NeoModal>

            {/* Modal Baixa Fatura */}
            <NeoModal
                isOpen={modalAction === "payment"}
                toggle={onClose}
                title="Registrar Pagamento Manual"
                footerActions={
                    <>
                        <NeoButton variant="secondary" onClick={onClose}>Cancelar</NeoButton>
                        <NeoButton variant="success" onClick={() => onPayFatura(selectedFatura.id)}>Confirmar Liquidação</NeoButton>
                    </>
                }
            >
                {selectedFatura && (
                    <div>
                        <p>Confirme a liquidação manual da fatura <strong>{selectedFatura.id}</strong> no valor de <strong>R$ {selectedFatura.amount.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</strong>.</p>
                        <Row className="g-3">
                            <Col md={6}>
                                <NeoInput
                                    label="Método Recebido"
                                    type="select"
                                    defaultValue="Pix"
                                    options={[
                                        { value: "Pix", label: "Pix Manual" },
                                        { value: "Transferencia", label: "Transferência Bancária" },
                                        { value: "Boleto", label: "Boleto Pago" },
                                        { value: "Permuta", label: "Cortesia / Bonificação" }
                                    ]}
                                />
                            </Col>
                            <Col md={6}>
                                <NeoInput label="Data de Recebimento" type="date" defaultValue={new Date().toISOString().split("T")[0]} />
                            </Col>
                        </Row>
                    </div>
                )}
            </NeoModal>
        </>
    );
};

DetailActionModals.propTypes = {
    modalAction: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    tenant: PropTypes.object,
    tempPlan: PropTypes.string,
    tempTrialStartDate: PropTypes.string,
    tempTrialEndsAt: PropTypes.string,
    platformPlans: PropTypes.array,
    loadingPlans: PropTypes.bool,
    changingPlan: PropTypes.bool,
    changingTrial: PropTypes.bool,
    onChangeTempPlan: PropTypes.func.isRequired,
    onChangeTempTrialStartDate: PropTypes.func.isRequired,
    onChangeTempTrialEndsAt: PropTypes.func.isRequired,
    onPlanChange: PropTypes.func.isRequired,
    onTrialChange: PropTypes.func.isRequired,
    onBlockToggle: PropTypes.func.isRequired,
    liberateDays: PropTypes.number,
    onChangeLiberateDays: PropTypes.func.isRequired,
    onLiberateTemporarily: PropTypes.func.isRequired,
    onImpersonate: PropTypes.func.isRequired,
    selectedFatura: PropTypes.object,
    onPayFatura: PropTypes.func.isRequired
};

export default DetailActionModals;
